<ng-container [ngSwitch]="mainService.getShopPortalLayoutKind()">
  <app-order-history-webshop *ngSwitchDefault></app-order-history-webshop>
  <!-- <app-order-history-old *ngSwitchCase="0"></app-order-history-old> -->
</ng-container>
